
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"object-fit":"cover"},style,staticStyle],
              attrs: Object.assign({"style":"object-fit:cover","version":"1","baseProfile":"full","viewBox":"0 0 1920 865","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h1920v865H0z"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"0","x2":"1","y1":"0","y2":"0"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#2255ff90"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#021e5190"}})])]),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",staticStyle:{"transform-origin":"center"},attrs:{"d":"M0 865V0v610h432V490h500v65h422v50h566v260z","fill":"url(#a)"}}),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",staticStyle:{"transform-origin":"center"},attrs:{"d":"M0 865V0v908-8h426v23h513V703h491v205h490v-43z","fill":"url(#a)"}})])
          )
        }
      }
    